import React from 'react';
import { IResource } from '@gettactic/api';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@cmp-src/@v2/components/ui/select';
import { cn } from '@gettactic/helpers/src';

export interface FloorSelectorProps {
  floors: IResource[];
  value?: string;
  onChangeFloor: (value: string) => void;
  className?: string;
  allowEmpty?: boolean;
  noFloorLabel?: string;
}

export const FloorSelector: React.FC<FloorSelectorProps> = ({
  floors,
  onChangeFloor,
  value,
  className,
  allowEmpty = false,
  noFloorLabel
}) => {
  return (
    <Select
      onValueChange={(value) => {
        onChangeFloor(value !== '0' ? value : '');
      }}
      value={value}
    >
      <SelectTrigger className={cn('mt-1 min-h-[42px] justify-between', className)}>
        <SelectValue placeholder="Select floor" /> 
      </SelectTrigger>
      <SelectContent>
        {allowEmpty && (
          <SelectItem value="0">{noFloorLabel || 'No floor'}</SelectItem>
        )}
        {floors.map((floor) => (
          <SelectItem key={floor.id} value={floor.id}>
            {floor.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
